import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';

function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view_custom', {
      page_path: location.pathname,
    });
  }, [location.pathname]);

  return null;
}

export default AnalyticsPageTracker;